// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerG_TheComp__PogyB"};